<template>
  <b-card class="rounded-0">
    <b-row>
      <b-col>
        <h3>
          {{ $t('message.addressConfirmForm.title') }}
          <small class="text-muted mx-2">
            {{ $t('message.addressConfirmForm.subtitle') }}
          </small>
        </h3>
      </b-col>
    </b-row>

    <b-row class="d-flex justify-content-center mt-4">
      <b-col cols="6">
        <address-form
          ref="addressForm"
          :address="currentAddress"
          :onSubmitFn="submit">
        </address-form>
      </b-col>
    </b-row>

    <b-row class="mt-3">
      <b-col cols="6">
        <b-button
          variant="link"
          @click="back">{{ $t('message.addressConfirmForm.btn.back') }}</b-button>
      </b-col>
      <b-col cols="6" class="text-right">
        <b-button
          variant="primary"
          @click="submit">{{ $t('message.addressConfirmForm.btn.submit') }}</b-button>
      </b-col>
    </b-row>
  </b-card>
</template>
<script>
  import AddressForm from '@/components/address/AddressForm'
  export default {
    name: 'AddressConfirmForm',
    components: {
      AddressForm
    },
    beforeRouteEnter (to, from, next) {
      next(vm => {
        const currentAddress = vm.$store.getters.currentAddress
        if (Object.keys(currentAddress).length === 0) {
          next('/addresses')
        }
      })
    },
    destroyed () {
      this.$store.commit('setCurrentAddress', {})
    },
    computed: {
      currentAddress () {
        return this.$store.getters.currentAddress
      }
    },
    methods: {
      back () {
        this.$router.push('/addresses')
      },
      submit () {
        const addressForm = this.$refs.addressForm
        addressForm.$v.$touch()
        if (!addressForm.$v.$invalid) {
          this.$store.dispatch('storeAddress', this.currentAddress)
            .then(() => {
              this.showSuccessMsg({
                message: this.$t('message.addressConfirmForm.storeAddress')
              })
              this.$router.push('/addresses')
            })
            .catch(() => {
              this.showErrorMsg({
                message: this.$t('error.addressConfirmForm.storeAddress')
              })
            })
        }
      }
    },
    notifications: {
      showSuccessMsg: {
        type: 'success'
      },
      showErrorMsg: {
        type: 'error'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/address/AddressConfirmForm.vue